module.exports = __webpack_public_path__ + "img/53.8000ad86.jpg";